import React, { useEffect, useState } from 'react';
import PreBoot from './preboot.jsx';
import KernelBoot from '../boot/KernelBoot';
import { playBootAudio } from '../audio/bootAudio';
import Terminal from '../terminal/Terminal';

const DevOverlay = () => {
    const [phase, setPhase] = useState('preboot');

    
    useEffect(() => {
        if (phase === 'kernel') {
            playBootAudio();
        }
    }, [phase]);

    return (
        <div className="bootRoot">
            {phase === 'preboot' && (
                <PreBoot onComplete={() => setPhase('kernel')} />
            )}

            {phase === 'kernel' && (
                <KernelBoot onComplete={() => setPhase('terminal')} />
            )}

            {phase === 'terminal' && <Terminal />}
        </div>
    );
};

export default DevOverlay;
